module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_015.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_015.png
// module id = 2331
// module chunks = 5